import { types } from "../action-types";

const initialState = {
  loading: false,
  success: false,
  error: false,
};

const createProjectReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CREATE_PROJECT_INIT:
      return { ...state, loading: true, success: false, error: false };
    case types.CREATE_PROJECT_SUCCESS:
      return { ...state, loading: false, success: true };
    case types.CREATE_PROJECT_FAILURE:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
};

export default createProjectReducer;
